<script>
    import BaseDialog from './BaseDialog.svelte';
    import Spinner from '../../work/spinner.svelte';
    import parse_tsv from '../parse_tsv2';
    import parse_tdf from '../parse_tdf';
    import parse_sad_with_aws from '../parse_sad_with_aws';

    let {
        dialogRef = $bindable(),
        autoloading,
        dataSetId,
        dataSetFileName,
        createTranscriptAuto,
        createTranscriptFiles = $bindable(),
        createTranscriptJson = $bindable(),
        createTranscriptText,
        createTranscriptTsv,
        createTranscriptTdf,
        createTranscriptSadWithAws,
        createTranscriptJsonn,
        ldcPermissions,
        onAdd,
        onAddSave,
        onUpload,
        btn = ""
    } = $props();
</script>

<BaseDialog bind:dialogRef={dialogRef} size="sm:max-w-4xl" title="Upload Transcript">
    {#snippet children({ dialog })}
        {#if autoloading}
            <div class="flex items-center justify-center p-8">
                <div class="text-center">
                    <Spinner />
                    <p class="mt-4 text-gray-600 font-medium">Loading Transcript...</p>
                </div>
            </div>
        {/if}
        <div class="overflow-auto">
            <div class="p-6 space-y-6">
                {#if dataSetId && dataSetFileName}
                    <div class="flex items-center justify-center p-6">
                        <div class="text-center">
                            <Spinner />
                            <p class="mt-3 text-gray-600 font-medium">Adding transcript...</p>
                        </div>
                    </div>
                {:else}
                    {#if !createTranscriptAuto}
                        <div class="border-2 border-dashed border-gray-300 rounded-lg p-6 hover:border-indigo-400 transition">
                            <label class="cursor-pointer block text-center">
                                <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
                                    <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p class="mt-2 text-sm text-gray-600">
                                    <span class="font-semibold text-indigo-600">Click to upload</span> or drag and drop
                                </p>
                                <p class="mt-1 text-xs text-gray-500">TSV, TDF, or JSON format</p>
                                <input type="file" bind:files={createTranscriptFiles} class="hidden">
                            </label>
                        </div>
                    {/if}

                    {#if (createTranscriptFiles && createTranscriptFiles[0]) || createTranscriptAuto}
                        <div class="space-y-4">
                            {#if createTranscriptJson}
                                <div class="bg-green-50 border border-green-200 rounded-lg p-4">
                                    <div class="flex items-center mb-3">
                                        <svg class="h-5 w-5 text-green-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                                        </svg>
                                        <span class="text-green-800 font-medium">File parsed successfully</span>
                                    </div>
                                    <div class="flex gap-3">
                                        <button class="{btn} flex-1" onclick={onAdd} data-close-dialog>Add Read Only</button>
                                        {#if ldcPermissions.admin || createTranscriptAuto}
                                            <button class="{btn} flex-1" onclick={onAddSave} data-close-dialog>Add and Save</button>
                                        {/if}
                                    </div>
                                </div>
                            {:else if createTranscriptText}
                                <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
                                    {#if createTranscriptTsv}
                                        <div class="flex items-center justify-between">
                                            <div class="flex items-center">
                                                <svg class="h-5 w-5 text-blue-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                    <path d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z"/>
                                                    <path d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"/>
                                                </svg>
                                                <span class="text-blue-800 font-medium">File appears to be TSV</span>
                                            </div>
                                            <button class="{btn}" onclick={() => createTranscriptJson = parse_tsv(createTranscriptText)}>Parse as TSV</button>
                                        </div>
                                    {:else if createTranscriptTdf}
                                        <div class="flex items-center justify-between">
                                            <div class="flex items-center">
                                                <svg class="h-5 w-5 text-blue-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                    <path d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z"/>
                                                </svg>
                                                <span class="text-blue-800 font-medium">File appears to be TDF</span>
                                            </div>
                                            <button class="{btn}" onclick={() => createTranscriptJson = parse_tdf(createTranscriptText)}>Parse as TDF</button>
                                        </div>
                                    {:else if createTranscriptSadWithAws}
                                        <div class="flex items-center justify-between">
                                            <div class="flex items-center">
                                                <svg class="h-5 w-5 text-blue-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                    <path d="M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z"/>
                                                </svg>
                                                <span class="text-blue-800 font-medium">File appears to be JSON</span>
                                            </div>
                                            <button class="{btn}" onclick={() => createTranscriptJson = parse_sad_with_aws(createTranscriptText)}>Parse as JSON</button>
                                        </div>
                                    {:else if createTranscriptJsonn}
                                        <div class="flex items-center justify-between">
                                            <div class="flex items-center">
                                                <svg class="h-5 w-5 text-blue-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                    <path d="M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z"/>
                                                </svg>
                                                <span class="text-blue-800 font-medium">File appears to be JSON</span>
                                            </div>
                                            <button class="{btn}" onclick={() => createTranscriptJson = JSON.parse(createTranscriptText)}>Parse as JSON</button>
                                        </div>
                                    {:else}
                                        <div class="flex items-center">
                                            <svg class="h-5 w-5 text-yellow-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                                            </svg>
                                            <span class="text-yellow-800 font-medium">Unknown format</span>
                                        </div>
                                    {/if}
                                </div>
                            {:else}
                                <div class="flex justify-center">
                                    <button class="{btn} px-8 py-3" onclick={onUpload}>Upload File</button>
                                </div>
                            {/if}
                        </div>
                    {/if}
                {/if}

                {#if createTranscriptJson || createTranscriptText}
                    <div class="border-t border-gray-200 pt-6">
                        <h5 class="text-sm font-medium text-gray-700 mb-3">
                            {#if createTranscriptJson}
                                Parsed Preview
                            {:else}
                                Original File Preview
                            {/if}
                        </h5>
                        <div class="bg-gray-50 rounded-lg p-4 max-h-64 overflow-auto">
                            {#if createTranscriptJson}
                                <pre class="text-xs text-gray-800 font-mono">{#each createTranscriptJson as x}{JSON.stringify(x) + "\n"}{/each}</pre>
                            {:else if createTranscriptText}
                                {#if createTranscriptTsv || createTranscriptTdf}
                                    <pre class="text-xs text-gray-800 font-mono">{createTranscriptText.split("\n").slice(0,9).join("\n")}</pre>
                                {:else if createTranscriptJsonn}
                                    <pre class="text-xs text-gray-800 font-mono">{createTranscriptText.substr(0,999)}</pre>
                                {:else if createTranscriptSadWithAws}
                                    <pre class="text-xs text-gray-800 font-mono">{JSON.stringify(createTranscriptText).substr(0,999)}</pre>
                                {/if}
                            {/if}
                        </div>
                    </div>
                {/if}
            </div>
        </div>
    {/snippet}
</BaseDialog>
